import * as React from 'react';
import styled from 'styled-components';
import { ICurrency } from '../types';
import { priceWithCommas } from '../../utils/commonHelper';
import t from '../locales';
import { getLocale } from '../../utils/pathHelper';

const View = styled.div`
  margin: 0 0 8px 0;
  padding: 0;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4em;
  &:hover {
    .name {
      text-decoration: underline;
    }
  }
  .name {
    display: block;
    color: var(--blue600);
    margin: 0;
  }
  span {
    margin-right: 4px;
    padding: 0;
    color: var(--gray600);
    font-size: 10px;
    font-weight: 400;
  }
  &:last-of-type {
    margin-bottom: 0;
  }
`;

interface IProps {
  currency: ICurrency,
  name: string,
  code: string,
  access_minutes?: number|null,
  lift_min_price?: number|null,
  rental_min_price?: number|null,
}

const YadoItemResort: React.FC<IProps> = (props) => {
  const { name, code, access_minutes, lift_min_price, rental_min_price } = props;

  function handleClick(event: React.MouseEvent) {
    event.stopPropagation();
    event.preventDefault();
    window.location.href = `/snow/resorts/${code}`;
  }

  function renderLocalPrice(jpyPrice: number): string {
    const { rate, code } = props.currency;
    const locale = getLocale();
    if (!jpyPrice || !rate || !code) { return null; }
    if (locale.toString() == 'ja') {
      return `${priceWithCommas(jpyPrice)}円`;
    } else {
      return `${code} ${priceWithCommas(jpyPrice * rate)}〜 (JPY ${Math.round(jpyPrice).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}～)`;
    };
  }

  return (
    <View>
      <p className="name" onClick={handleClick}>
        {name}
      </p>
      <div>
        {access_minutes && <span>{t.minutes({ minutes: access_minutes })}</span>}
        {lift_min_price && <span>{`${t.lift()} ${renderLocalPrice(lift_min_price)}`}</span>}
        {rental_min_price && <span>{`${t.rental()} ${renderLocalPrice(rental_min_price)}`}</span>}
      </div>
    </View>
  );
};

export default YadoItemResort;
